import React from 'react';
import GridMultiSelect from './GridMultiSelect';

// Drop-in for MUI <Select multiple>{MenuItems}</Select>: chips + grid where each click adds/removes.
const flatten = (children) => {
    const out = [];
    React.Children.forEach(children, (ch) => {
        if (!ch) return;
        if (ch.type === React.Fragment) out.push(...flatten(ch.props.children));
        else out.push(ch);
    });
    return out;
};
const textOf = (n) => {
    if (n === null || n === undefined || typeof n === 'boolean') return '';
    if (typeof n === 'string' || typeof n === 'number') return String(n);
    if (Array.isArray(n)) return n.map(textOf).join('');
    if (n.props) return (n.props.primary !== undefined ? textOf(n.props.primary) : '') + textOf(n.props.children);
    return '';
};

export default function GridMultiSelectField(props) {
    const { children, name, value, onChange, label, error, disabled, gridColumns } = props;
    const options = flatten(children)
        .filter((ch) => ch && ch.props && ch.props.value !== undefined && ch.props.value !== '')
        .map((ch) => ({ value: ch.props.value, label: textOf(ch.props.children).trim() || String(ch.props.value) }));
    return (
        <GridMultiSelect
            label={typeof label === 'string' ? label : ''}
            values={Array.isArray(value) ? value : []}
            options={options}
            columns={gridColumns}
            error={!!error}
            disabled={disabled}
            onChange={(vals) => onChange && onChange({ target: { name, value: vals }, persist: () => {} })}
        />
    );
}
